<script setup>
import { Head, Link, useForm } from '@inertiajs/vue3';
import HsAuthenticationCard from '@/Components/AuthenticationCard.vue';
import HsAuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue';
import HsButton from '@/Components/Button.vue';
import HsInput from '@/Components/Input.vue';
import HsValidationErrors from '@/Components/ValidationErrors.vue';

defineProps({
    status: String,
});

const form = useForm({
    email: '',
});

const submit = () => {
    form.post(route('password.email'));
};
</script>

<template>

    <Head title="Forgot Password" />

    <HsAuthenticationCard>

        <!-- /Left Text -->
        <div class="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
            <div class="w-100 d-flex justify-content-center">
                <img src="/ui/img/illustrations/girl-unlock-password-light.png" class="img-fluid" alt="Login image"
                    width="600" data-app-dark-img="illustrations/girl-unlock-password-dark.png"
                    data-app-light-img="illustrations/girl-unlock-password-light.png" />
            </div>
        </div>
        <!-- /Left Text -->

        <!-- Forgot Password -->
        <div class="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
            <div class="w-px-400 mx-auto">
                <!-- Logo -->
                <HsAuthenticationCardLogo />
                <!-- /Logo -->
                <h4 class="mb-2">Forgot Password?</h4>
                <p class="mb-4">Enter your email and we'll send you instructions to reset your password</p>
                <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                    {{ status }}
                </div>
                <HsValidationErrors class="mb-0" />
                <form @submit.prevent="submit" class="mb-3">
                    <div class="mb-3">
                        <label for="email" class="form-label">Email</label>
                        <HsInput id="email" v-model="form.email" type="email" class="form-control"
                            placeholder="Enter your email" required autofocus />
                    </div>
                    <HsButton class="btn btn-primary d-grid w-100" :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing">
                        Send Reset Link
                    </HsButton>
                </form>
                <div class="text-center">
                    <Link :href="route('login')" class="d-flex align-items-center justify-content-center">
                    <i class="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
                    Back to login
                    </Link>
                </div>
            </div>
        </div>
        <!-- /Forgot Password -->
    </HsAuthenticationCard>
</template>
